import { Col, Divider, Row } from 'antd'
import React from 'react'
import { connect } from 'react-redux'
import './style.scss'
import SalaryCardFilterBar from './feature/SalaryCardFilterBar'
import SalaryCardList from './entities/SalaryCardList'
import SalaryCardFooterBar from './feature/SalaryCardFooterBar'
import ContentBox from '@shared/ContentBox'
import { useTranslation } from 'react-i18next'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import {orderFilterSchema} from './models/orderListFilter.schema'
import { SalaryCardListRequest } from 'store/reducers/salaryCards/salaryCardList.api'
import { tabsItems } from './constants/tabsItems.constant'

function SalaryCardOrder() {
  const { t } = useTranslation()

  const methods = useForm<SalaryCardListRequest>({
    mode: 'all',
    resolver: yupResolver(orderFilterSchema),
    defaultValues: {
      page: 1,
      pageCount: 10,
      searchText: '',
    },
  })

  return (
    <ContentBox title={t('orders.newOrderscards')} activeKey='item-1' items={tabsItems()}>
      <FormProvider {...methods}>
        <Row style={{ flexDirection: 'column', gap: 20 }}>
          <Col span={24} order={0}>
            <SalaryCardFilterBar />
          </Col>
          <Col span={24} order={2}>
            <SalaryCardFooterBar />
          </Col>
          <Col span={24}>
            <Divider type="horizontal" />
            <SalaryCardList />
          </Col>
        </Row>
      </FormProvider>
    </ContentBox>
  )
}

const mapStateToProps = (state: any) => {
  return {
    leftMenuStatus: state.home.leftMenuStatus,
  }
}

export default connect(mapStateToProps, null)(SalaryCardOrder)
